DataTable; // PaymentList.tsx
import React, { useEffect, useState } from "react";
import style from "./paymentList.module.css";
import PageHeader from "../../../components/pageHeader/pageHeader";
import axios from "axios";
import { ErrorToast } from "../../../components/toastMessage";
import Table, {
  tableCustomStyles,
} from "../../../components/CommonComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "../../../hooks/common";
import { getApplicationTypeColumnLabel } from "../../../config/phaseConstants";
import Paginator, {
  PaginatorForRDT,
} from "../../../components/CommonComponents/Paginator/Paginator";
import Dropdown from "react-bootstrap/Dropdown";
import { useSetUser, useUser } from "../../../contexts/UserContext";
import { BASE_URL } from "../../../constants/Constants";
import PayNow from "../../../assets/paynow.svg";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import DataTable, { TableColumn } from "react-data-table-component";
import EditButton, {
  PayButton,
  ViewButton,
} from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";
import { formatDate } from "../../../utils/date";

interface Row {
  srNo: number;
  itemName: string;
  date: string;
  second_date: string;
  status: string;
}

const PaymentList: React.FC = () => {
  const [paymentList, setPaymentList] = useState<Array<any>>([]);
  const [isGridView, setIsGridView] = useState(false);
  const navigate = useNavigate();
  const userObj = useUser();
  const setUser = useSetUser();

  const [totalList, setTotalList] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const isArchitectOrUser = ["user", "architect"].includes(
    userObj?.role?.toLowerCase() || ""
  );
  const isAdmin = userObj?.role?.toLowerCase()?.includes("admin");

  const columns = [
    {
      name: "Application ID",
      width: "180px",
      selector: (row: any) => row.application_id,
      sortable: true,
      grow: 2,
    },
    {
      name: "Plot Owner's Name",
      selector: (row: any) => row.plot_owner_s_name,
      sortable: true,
      grow: 2,
    },
    {
      name: "Application Type",
      selector: (row: any) => getApplicationTypeColumnLabel(row),
      center: true,
      width: "180px",
    },
    {
      name: "Payment Status",
      width: "230px",
      selector: (row: any) => row.status,
      cell: (row: any) => <span className="text-center">{row.status}</span>,
      sortable: true,
      sortFunction: (rowA: any, rowB: any) => {
        const a = rowA.status.toLowerCase();
        const b = rowB.status.toLowerCase();
        if (a > b) return 1;
        if (b > a) return -1;
        return 0;
      },
      grow: 2,
    },
    {
      name: "Created By",
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: "Created On",
      selector: (row: any) => formatDate(new Date(row.created_at)),
      sortable: true,
      width: "170px",
    },
    {
      name: "Modified By",
      selector: (row: any) => row.modified_by,
      cell: (row: any) => (
        <span className="text-center">{row.modified_by}</span>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Modified On",
      selector: (row: any) => formatDate(new Date(row.updated_at)),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action",
      grow: 1,
      width: "150px",
      selector: (row: any) => (
        // <div className={style.buttonTogether}>
        //   <button
        //     onClick={() => handleViewClick(row)}
        //     className="icon-button"
        //   >
        //     <i className="m-0 fa fa-eye"></i>
        //   </button>
        //   <img
        //     src={PayNow}
        //     alt="Pay Now"
        //     onClick={() => handlePayNowClick(row)}
        //     style={{
        //       cursor: 'pointer',
        //       border: '2px #2b66ff',
        //       borderRadius: '5px',
        //       padding: '5px',
        //       backgroundColor: '#2b66ff',
        //       width: '32px'
        //     }}
        //   />
        // </div>
        <div className="flex space-x-2">
          <ViewButton onClick={() => handleViewClick(row)} />
          <PayButton onClick={() => handlePayNowClick(row)} />
        </div>
      ),
      sortable: false,
    },
  ];

  useEffect(() => {
    getPaymentList();
  }, [currentPage, search, selectedFilters]);

  const getPaymentList = () => {
    const apiUrl = `${BASE_URL}/api/paymentList/list`;
    const requestData = {
      page: currentPage,
      limit: entriesPerPage,
      search: search,
      filters: selectedFilters,
      userId: userObj?.user_id,
    };

    console.log("Sending API request:");
    console.log("URL:", apiUrl);
    console.log("Request Body:", requestData);

    _axios
      .post(apiUrl, requestData)
      .then(function (response) {
        console.log(response.data);
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setTotalList(response.data.data.total_rows);
        setPaymentList([...response.data.data.results]);

        console.log(response);
      })
      .catch(function (error: any) {
        console.log(error);
      });
  };

  const handleViewClick = (row: any) => {
    navigate("/view-user-payment", {
      state: {
        user: {
          ...row,
          id: row.id,
          application_id: row.application_id,
        },
        paymentStatus: row.payment_status,
      },
    });
  };

  const handlePayNowClick = (row: any) => {
    navigate("/pay-now", {
      state: {
        user: {
          ...row,
          id: row.id, // Assuming `id` is available in `row`
          application_id: row.application_id,
        },
        paymentStatus: row.payment_status,
        id: row.id,
      },
    });
  };

  const handleFilterChange = (filter: string) => {
    const index = selectedFilters.indexOf(filter);
    if (index === -1) {
      setSelectedFilters([...selectedFilters, filter]);
    } else {
      const updatedFilters = [...selectedFilters];
      updatedFilters.splice(index, 1);
      setSelectedFilters(updatedFilters);
    }
  };

  const handlePageChange = (page: React.SetStateAction<number>) => {
    setCurrentPage(page);
  };
  console.log("Total rows:", totalList);

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className={style.DropDropMenu}>
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropTile}>
              Payment List filter
            </Dropdown.Header>
            <ul>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Pending Payment")}
                    onChange={() => handleFilterChange("Pending Payment")}
                  />{" "}
                  <label className={style.filterLable}>Pending Payment</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Returned By Accountant")}
                    onChange={() => handleFilterChange("Returned By Accountant")}
                  />{" "}
                  <label className={style.filterLable}>Returned By Accountant</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Payment Discrepancy")}
                    onChange={() => handleFilterChange("Payment Discrepancy")}
                  />{" "}
                  <label className={style.filterLable}>Payment Discrepancy</label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Pending Level 1 Final Review"
                    )}
                    onChange={() =>
                      handleFilterChange("Pending Level 1 Final Review")
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Pending Level 1 Final Review{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Returned For Repayment By Level 1 Reviewer"
                    )}
                    onChange={() =>
                      handleFilterChange(
                        "Returned For Repayment By Level 1 Reviewer"
                      )
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Returned For Repayment By Level 1 Reviewer{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Returned For Repayment By Level 2 Reviewer"
                    )}
                    onChange={() =>
                      handleFilterChange(
                        "Returned For Repayment By Level 2 Reviewer"
                      )
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Returned For Repayment By Level 2 Reviewer{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Returned For Repayment By Level 3 Reviewer"
                    )}
                    onChange={() =>
                      handleFilterChange(
                        "Returned For Repayment By Level 3 Reviewer"
                      )
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Returned For Repayment By Level 3 Reviewer{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Pending Level 2 Final Review"
                    )}
                    onChange={() =>
                      handleFilterChange("Pending Level 2 Final Review")
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Pending Level 2 Final Review{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes("Pending Final Review")}
                    onChange={() => handleFilterChange("Pending Final Review")}
                  />{" "}
                  <label className={style.filterLable}>
                    Pending Final Review
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Payment Rejected By Level 2 Reviewer"
                    )}
                    onChange={() =>
                      handleFilterChange("Payment Rejected By Level 2 Reviewer")
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Payment Rejected By Level 2 Reviewer{" "}
                  </label>
                </div>
              </li>
              <li>
                <div className={style.dropdownContent}>
                  <input
                    type="checkbox"
                    className={style.checkBoxDrop}
                    checked={selectedFilters.includes(
                      "Payment Rejected By Level 3 Reviewer"
                    )}
                    onChange={() =>
                      handleFilterChange("Payment Rejected By Level 3 Reviewer")
                    }
                  />{" "}
                  <label className={style.filterLable}>
                    {" "}
                    Payment Rejected By Level 3 Reviewer{" "}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  return (
    <div className={style.bodyBox}>
      <div className={`${style.whiteBody} `}>
        <PageHeader
          title="Payment List"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={false}
          buttonTitle=""
          isGridView={isGridView}
          onGridIconClick={() => setIsGridView(!isGridView)}
          showFilterButton={true}
          dropdownContent={dropdownContent}
        />
        {isGridView ? (
          <>
            <BoxComponent>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {paymentList
                  ?.filter((row: any) =>
                    row.application_id
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase())
                  )
                  .map((row: any) => {
                    return (
                      <div className="p-4 rounded-2xl bg-white shadow-lg flex flex-col border border-gray-300">
                        <div className="flex justify-between items-center space-x-4 mb-4">
                          <div
                            className={
                              "text-center bg-yellow-500 text-grey-600 inline-block py-1 px-4 sm:px-2 rounded-full text-sm text-[12px] font-semibold"
                            }
                          >
                            {row?.status ?? "-"}
                          </div>
                          <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-2">
                            {/* <img
                              src={PayNow}
                              alt="Pay Now"
                              onClick={() => handlePayNowClick(row)}
                              style={{
                                cursor: 'pointer',
                                border: '2px #2b66ff',
                                borderRadius: '5px',
                                padding: '5px',
                                backgroundColor: '#2b66ff',
                                width: '32px'
                              }}
                            />
                            <button
                              onClick={() => handleViewClick(row)}
                              className="icon-button"
                            >
                              <i className="m-0 fa fa-eye"></i>
                            </button> */}
                            <ViewButton onClick={() => handleViewClick(row)} />
                            <PayButton onClick={() => handlePayNowClick(row)} />
                          </div>
                        </div>
                        <div className="mb-2 flex">
                          <p className="font-bold text-base w-1/2">
                            Application ID
                          </p>
                          <p className="text-base mx-2">:</p>
                          <p className="text-base w-2/3">
                            {row?.application_id}
                          </p>
                        </div>
                        <div className="mb-2 flex">
                          <p className="font-bold text-base w-1/2">
                            Plot Owner's Name
                          </p>
                          <p className="text-base mx-2">:</p>
                          <p className="text-base w-2/3">
                            {row?.plot_owner_s_name || "-"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <Paginator
                limit={entriesPerPage}
                page={currentPage}
                setPage={handlePageChange}
                count={totalList || 0}
              />
            </BoxComponent>
          </>
        ) : (
          <BoxComponent>
            <Table
              columns={columns}
              data={paymentList}
              pagination
              paginationTotalRows={totalList || 0}
              onChangePage={(p) => {
                console.log("setCurrentPage", p);
                setCurrentPage(p);
              }}
              customStyles={tableCustomStyles}
              paginationComponent={PaginatorForRDT}
            />
          </BoxComponent>
        )}
      </div>
    </div>
  );
};
export default PaymentList;
